var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 157,
    viewBox: "0 0 150 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.704 17.4369C148.937 26.7651 148.937 39.7509 148.937 65.7223C148.937 91.6937 148.937 104.679 142.704 114.008C140.005 118.046 136.538 121.513 132.5 124.212C124.351 129.657 113.411 130.345 93.4604 130.432V130.445L83.2382 150.889C79.8308 157.704 70.1058 157.704 66.6984 150.889L56.4762 130.445V130.432C36.526 130.345 25.5859 129.657 17.4369 124.212C13.3986 121.513 9.93126 118.046 7.23295 114.008C1 104.679 1 91.6937 1 65.7223C1 39.7509 1 26.7651 7.23295 17.4369C9.93126 13.3986 13.3986 9.93126 17.4369 7.23295C26.7651 1 39.7509 1 65.7223 1H84.2144C110.186 1 123.172 1 132.5 7.23295C136.538 9.93126 140.005 13.3986 142.704 17.4369Z",
    fill: "currentColor",
    fillOpacity: 0.05,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2305 47.2302L102.707 47.2302",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2305 84.2144H74.9686",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDiscussion);
export default __webpack_public_path__ + "static/media/no-discussion.acd15f76e0e8aa18dd5df3343fb07e2b.svg";
export { ForwardRef as ReactComponent };